import { Injectable } from '@angular/core';
import { UserService } from '../auth/services/user.service';
import { Observable, takeWhile } from 'rxjs';
import { CurrentUser, getCurrentUser$ } from '../data-access/users';
import { Firestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class GetCurrentUserService {
  constructor(private userService: UserService, private firestore: Firestore) {
  }

  get(uid: string): Observable<CurrentUser> {
    return getCurrentUser$(this.firestore, uid).pipe(
      takeWhile(() => !!this.userService.currentUser),
    );
  }
}
